import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SpecialRequestDto {
    nombre: string;
    cedula: string;
    email: string;
    telefono: string;
    quoteId: number;
}

export interface SpecialRequestResponse {
    message: string;
    quoteId: number;
}

@Injectable({
    providedIn: 'root',
})
export class SpecialRequestsService {
    private readonly httpClient = inject(HttpClient);
    private readonly controller = 'special-requests';

    submit(request: SpecialRequestDto): Observable<SpecialRequestResponse> {
        return this.httpClient.post<SpecialRequestResponse>(this.controller, request);
    }
}
